import { applyFilters } from "./applyFilters";

export function searchRecord(options: any) {
	const { searchRecords } = options;

	return (data: any, _: string | Record<string, string[]>) => {
		return applyFilters(data, searchRecords);
	};
}
